import cls from "classnames";

export default function PostTag({ label, icon = "", unicode = "", className }) {
  return (
    <div
      className={cls(
        "flex items-center space-x-2 px-3 py-2 bg-[#2D3339] rounded-full dark:bg-[#F2F5F8]",
        className
      )}
    >
      {unicode && <span className="text-[16px] leading-[16px]">{unicode}</span>}
      {icon && <img src={icon} alt="" className="w-[18px] h-[18px]" />}
      <span className="font-inter text-xs leading-[150%] dark:text-[#161A1D]">{label}</span>
    </div>
  );
}
